import * as yup from 'yup';

export const borrowerBonificationSchema = yup.object({
  title: yup.string(),
  description: yup.string(),
});

export type BorrowerBonificationForm = yup.InferType<typeof borrowerBonificationSchema>;
